module.exports = __webpack_public_path__ + "style/img/Group 2165.a5381cff.png";